import { Injectable } from '@angular/core';
import { CommsService } from '../../services/comms/comms.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { DisplayService } from '../../services/display/display.service';
import { NoteService } from '../../services/note/note.service';
import { TabService } from '../tab/tab.service';
import _ from 'lodash';
@Injectable()

export class CalendarService {

	objString = 'Invoice Calendar';
	objRoot = 'invoicecalendar';
	listRoot = 'invoicecalendars';
	dataObj = 'invoicecalendar';

	poDataObj = 'poinvoicecalendar';

	addButton = 'Add New Celendar';
	addTitle = 'Create Calendar';
	editTitle = 'Edit Calendar';
	formTitle = '';
	removeInvoiceDatesMessage = '';
	removeBillingDatesMessage = '';
	// lookup object of default calendar ID for its countrycode, {countrycode: defaultID,.....,...}
	defaultIDs: any = {};

	tabsData = {
		listTabs: [
			{
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				type: 'standard',
				page: 0
			}
		]
	};

	calendars = [];

	constructor(
		private commsService: CommsService,
		private dataService: DataService,
		private configService: ConfigService,
		private displayService: DisplayService,
		private noteService: NoteService,
		private tabService: TabService
	) { }


	tableClick(event) {
		console.log('INVOICE CAL TABLE CLICK: ', event);
		const clickedRow = event.row;
		const self = this;
		this.clearMessages();

		// have to close form and pause
		// otherwise InvoiceCalendarEntriesComponent wont be re-inited for each click
		this.formTitle = '';
		setTimeout(function () {
			self.openCalendar(clickedRow);
		}, 100);
	}

	tablePage(event) {
		console.log('INVOICE CAL TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.getActiveTab(this.tabsData.listTabs)['page'] = event.offset;
		this.loadCalendarsForTab(activeTab);
	}

	getAllTab() {
		return this.tabsData.listTabs[0];
	}

	getActiveTab(tabsData): any {
		let activeTab = {};
		tabsData.forEach(function (d, i) {
			if (d.active) {
				activeTab = d;
			}
		});
		return activeTab;
	}

	selectDefaultTab(tabsData) {
		const self = this;
		tabsData.forEach(function (d, i) {
			tabsData[i].active = false;
			tabsData[i].cached = false;
		});
		let foundDefault = false;
		let defaultIndex = -1;
		tabsData.forEach(function (d, i) {
			console.log('CHECK TAB FOR DEFAULT', d, self.tabService.showTab(d.persona, d.notPersona));
			if (self.tabService.showTab(d.persona, d.notPersona) && !foundDefault) {
				foundDefault = true;
				defaultIndex = i;
				if (d.listTab) {
					self.loadCalendarsForTab(d);
				}
			}
		});
		tabsData[defaultIndex].active = true;
		console.log('SELECTED DEFAULT TAB', tabsData);
	}

	selectActiveTab(tabsData, tabProp) {
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				if (d.listTab) {
					self.loadCalendarsForTab(d);
				}
			}
		});
	}

	checkTabs(tabsData) {
		// expected method, no logic needed for po page tabs
		// see same method in contractorService for example of use
	}

	loadCalendarsForTab(tab, data = null) {
		console.log('LOAD INVOICES FOR TAB', tab);
		this.loadCalendars(tab, data);
	}

	openCalendar(data) {
		console.log('OPEN INVOICE CAL', data);
		Object.keys(this.configService.countryCodes).forEach( (key) =>{
			if ( this.configService.countryCodes[key].indexOf(data['countrycode']) >= 0) {
				// create a new prop of country key used in shouldShow to hide/show some props
				data[key] = true;
			} else {
				data[key] = false;
			}
		});

		this.dataService.updateCalendarDetails(data);
		this.formTitle = this.editTitle;
	}

	populateNewCalendar() {
		const self = this;
		const invoiceCalDetails = {};
		this.configService.getDataObj(this.dataObj)['fields'].forEach(function (d, i) {
			if (d.validate !== self.configService.validateCalendarEntriesProp) {
				invoiceCalDetails[d.prop] = '';
			} else {
				invoiceCalDetails[d.prop] = [];
			}
		});
		// reset cal details
		invoiceCalDetails['countryname'] = '';
		Object.keys(this.configService.countryCodes).forEach( (key) =>{
			invoiceCalDetails[key] = false;
		});

		invoiceCalDetails[this.configService.invoiceCalIsMonthlyProp] = false;
		this.dataService.updateCalendarDetails(invoiceCalDetails);
	}

	getCalendarDetails(calendarId) {
		let calendarDetails = {};
		const self = this;
		try {
			self.dataService.invoiceCalendars.forEach(cal => {
				if (cal[self.configService.invoiceCalIdProp] === calendarId) {
					calendarDetails = cal;
				}
			});
		} catch (e) {
			console.error('error ocurred during retrieving calendar details', e);
		}
		return calendarDetails;
	}

	loadCalendars(tab, data = null) {
		console.log('LOAD INVOICE CALS');
		const self = this;

		this.displayService.startLoading();
		this.calendars = [];
		this.defaultIDs = {};
		this.commsService.getCalendarList(tab, data).subscribe((res) => {
			self.displayService.endLoading();
			console.log('LOAD INVOICE CALS RES', res);
			const successData = self.commsService.getSuccessData(res);
			this.calendars = _.cloneDeep(successData);
			const count = self.commsService.getSuccessCount(res);
			successData.forEach(calendar => {
				if (calendar[this.configService.calendarIsDefaultProp]) {
					this.defaultIDs[calendar.countrycode] = calendar.id;
				}
				if (!calendar.events) {
					calendar.events = [];
				} else {
					calendar.events.forEach(event => {
						event.readOnly = self.isInvoiceDateReadOnly(event.billingstart);
					});
				}
				if (!calendar.invoicedates) {
					calendar.invoicedates = [];
				} else {
					// has to convert array of date string to array of date object for ngModel
					// ngModel only works with object
					// need convert back when submit cal (in the method of submitInvoiceCal)
					const dateObjs = [];
					calendar.invoicedates.forEach(date => {
						dateObjs.push({
							invoicedate: date,
							readOnly: self.isInvoiceDateReadOnly(date)
						});
					});
					calendar.invoicedates = dateObjs;
				}
			});

			console.log('PARSED INVOICE CALS RES', successData);

			const dataRef = self.dataObj + '-' + tab.prop + '-' + tab.type;
			self.dataService.updatePageData(dataRef, tab, successData);
			self.dataService.updateInvoiceCalendars(successData);
			self.dataService.updateDataCount(dataRef, count);

			self.formTitle = '';

		}, (err) => {
			this.displayService.endLoading();
			self.commsService.handleAPIError('Load Invoice Calendars', err);
		});
	}

	submitInvoiceCal(data) {
		const self = this;
		this.displayService.startLoading();
		// need convert invoicedates back to an array of date string
		if (data.invoicedates) {
			const dates = [];
			data.invoicedates.forEach(date => {
				dates.push(date.invoicedate);
			});
			data.invoicedates = dates;
		}
		// need remove UI parms
		Object.keys(this.configService.countryCodes).forEach( (key) =>{
			delete data[key];
		});

		// remove prop percontractor (At Contractor Level)
		delete data['percontractor'];
		this.commsService.sendInvoiceCal(data).subscribe((res) => {
			const successData = self.commsService.getSuccessData(res);
			console.log('SUBMIT INVOICE CAL RES', res);
			self.noteService.displaySuccess('The invoice calendar has been submitted successfully.');
			this.selectDefaultTab(this.tabsData.listTabs);
			this.displayService.endLoading();
		}, (err) => {
			this.displayService.endLoading();
			self.commsService.handleAPIError('Submit Invoice Calendar', err);
		});
	}

	deleteInvoiceCal(data) {
		const self = this;

		this.displayService.startLoading();
		this.commsService.removeInvoiceCal(data).subscribe((res) => {
			self.displayService.endLoading();
			const successData = self.commsService.getSuccessData(res);
			console.log('SUBMIT INVOICE CAL RES', res);

			self.noteService.displaySuccess('The invoice calendar has been deleted successfully.');
			this.selectDefaultTab(this.tabsData.listTabs);

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Delete Invoice Calendar', err);
		});
	}

	isAllDatesEntered(dates, type, isMonthly = false) {
		// no need check for monthly billing dates
		if (type === 'events' && isMonthly) {
			return true;
		}

		// for non-monthly calendar, neither dates could be empty
		if ((!dates || dates.length === 0) && !isMonthly) {
			return false;
		}

		// check billing dates for non monthly calendar
		if (type === 'events' && !isMonthly) {
			for (let i = 0; i < dates.length; i++ ) {
				if (  !dates[i].billingstart || !dates[i].billingend) {
					return false;
				}
			}
		}

		// check invoicedates
		if (type === 'invoicedates') {
			for (let i = 0; i < dates.length; i++ ) {
				if (!dates[i].invoicedate) {
					return false;
				}
			}
		}

		return true;
	}

	/**
	 * Returns true if all dates given in the list are sequential, in ascending order
	 * @param dates list of dates as string that can be parsed by "Date.parse()"
	 */
	areAllDatesSequential(dates) {
		let prevDate;
		for (let i = 0; i < dates.length; i++) {
			const currDate = Date.parse(dates[i]);
			if (prevDate > currDate) {
				return false;
			}
			prevDate = currDate;
		}
		return true;
	}

	clearMessages() {
		this.removeInvoiceDatesMessage = '';
		this.removeBillingDatesMessage = '';
	}

	isInvoiceDateReadOnly(date) {
		let readOnly = false;
		const iDate = new Date(date);
		const today = new Date();
		if (iDate <= today) {
			readOnly = true;
		}
		return readOnly;
	}

	getCalendarName(id) {
		let calName = '';
		if (id && this.calendars && this.calendars.length > 0) {
			const cals = this.calendars.filter(cal => {
				return cal['_id'] === id;
			});
			if (cals && cals.length > 0) {
				calName = cals[0].name;
			}
		}
		return calName;
	}

	loadAllCountryNames() {
		this.commsService.getCountries().subscribe((res) => {
			console.log('LOAD ALL COUNTRY CODES: ', res);
			const successData = this.commsService.getSuccessData(res);
			this.dataService.countries = successData;
			const countryNames = Object.keys(successData);
			countryNames.push('');
			this.dataService.updateCountryNames(countryNames);
		}, (err) => {
			this.commsService.handleAPIError('Load All Countries', err);
		});
	}
}
